import actions from '../actions/public_quotes';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
